const PublicContainer = ({ children }: { children: JSX.Element }) => {
	return (
		<main className="content-container account-login" id="main-content">
			<div className="container">{children}</div>
		</main>
	);
};

export default PublicContainer;
